export default "__VITE_ASSET__eIfzUhTt__"